// extracted by mini-css-extract-plugin
module.exports = {"section2_J":"b2bFounder_section2_J__OMvPI","core_hd_J":"b2bFounder_core_hd_J__2hLBc","core_content_J":"b2bFounder_core_content_J__30fn3"};